__turbopack_context__.v({
  "feature": "features-module-scss-module__3tGwna__feature",
  "featureIcon": "features-module-scss-module__3tGwna__featureIcon",
  "featureTitle": "features-module-scss-module__3tGwna__featureTitle",
  "features": "features-module-scss-module__3tGwna__features",
  "featuresColumn": "features-module-scss-module__3tGwna__featuresColumn",
  "featuresContainer": "features-module-scss-module__3tGwna__featuresContainer",
  "featuresCta": "features-module-scss-module__3tGwna__featuresCta",
  "featuresCtaBtn": "features-module-scss-module__3tGwna__featuresCtaBtn",
  "featuresRow": "features-module-scss-module__3tGwna__featuresRow",
});
